<template>
	<div>
		<o-skeleton width="6em" :count="2"></o-skeleton>
	</div>
</template>
<script>
	export default {
		setup(props, context) {
			return {};
		}
	};
</script>